<section class="xr-card xr-profile-section" aria-labelledby="profile-data-title">
  <app-user-profile-image class="xr-profile-photo" [user]="user"></app-user-profile-image>
  <app-personal-details class="xr-profile-details" [user]="user"></app-personal-details>
</section>
<app-change-password></app-change-password>
